export default "__VITE_ASSET__DYdNa52N__"